export default __webpack_public_path__ + "static/media/Text_Format_Clear.37797bd8.svg";